var render, staticRenderFns
import script from "./formatterColumn.vue?vue&type=script&lang=js&"
export * from "./formatterColumn.vue?vue&type=script&lang=js&"
import style0 from "./formatterColumn.vue?vue&type=style&index=0&id=0f8032ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8032ed",
  null
  
)

export default component.exports